import type { DataQuality } from '../api/types'

/**
 * Status messaging.
 *
 * Every banner pairs an icon with its text, so state never rests on color alone.
 */
export function Banner({
  tone = 'info',
  children,
}: {
  tone?: 'info' | 'warning' | 'critical'
  children: React.ReactNode
}) {
  const icon = tone === 'critical' ? '✕' : tone === 'warning' ? '!' : 'i'
  return (
    <div className={`banner banner--${tone}`} role={tone === 'info' ? undefined : 'alert'}>
      <span className="banner__icon" aria-hidden="true">
        {icon}
      </span>
      <div>{children}</div>
    </div>
  )
}

/** Surfaces incomplete windows, which otherwise read as a genuine traffic drop. */
export function QualityBanner({ quality }: { quality: DataQuality }) {
  if (quality.status === 'pass') return null

  if (quality.status === 'empty') {
    return (
      <Banner tone="warning">
        <strong>No data for this window.</strong> GA4 returned no rows — check the property
        has traffic in this range, or pick a different range.
      </Banner>
    )
  }

  return (
    <Banner tone="warning">
      <strong>
        Partial data: {quality.days_returned} of {quality.days_expected} days returned.
      </strong>{' '}
      {quality.notes.join(' ')} Totals below are lower than the true figures.
    </Banner>
  )
}
